import React from 'react';
import { useGlobalDialogContext } from 'App/components/Layouts/Dashboard/dialog/GlobalDialog';
import requestService from 'store/request/service';
import { ConfirmPurgeDocumentForeverDialog } from './index';

export const ConfirmPurgeDocumentForeverGlobalDialog = ({
  document,
  candidateFullName,
}: any) => {
  const { hideDialog } = useGlobalDialogContext();

  const [removeDocument, { isLoading, isSuccess }] =
    requestService.endpoints.purgeDocumentForever.useMutation();

  const handleDialogToggle = () => {
    hideDialog();
  };

  const handlePurge = () => {
    removeDocument({
      documentRequestId: document.documentRequestId,
      candidateDocumentId: document.candidateDocumentId,
    });
  };

  return (
    <ConfirmPurgeDocumentForeverDialog
      open={true}
      setOpen={() => {
        handleDialogToggle();
      }}
      isLoading={isLoading || isSuccess}
      isSuccess={isSuccess}
      candidateFullName={candidateFullName}
      documentType={document.documentType}
      onPurge={handlePurge}
    />
  );
};
